import script from "./LegalNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalNotice.vue?vue&type=script&setup=true&lang=js"

import "./LegalNotice.vue?vue&type=style&index=0&id=4870b065&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4870b065"]])

export default __exports__